/**
 * @file Global Fragments for Selfie Station.
 */

import gql from 'graphql-tag';

export const PhotoUrlTypeFields = gql`
  fragment PhotoUrlTypeFields on PhotoURLType {
    url
    width
    height
    size_code
  }
`;

export const PhotoThumbnails = gql`
  fragment PhotoThumbnails on Photo {
    id
    thumbnail_urls {
      ...PhotoUrlTypeFields
    }
  }
  ${PhotoUrlTypeFields}
`;
